import { useTheme } from "react-native-paper";
import Container from "../Container";
import type { ContainerProps } from "../Container";

const AuthContainer = (props: ContainerProps) => {
	const theme = useTheme();
	return (
		<Container
			maxWidth="xs"
			containerStyle={{
				paddingVertical: 24,
				paddingHorizontal: 16,
				flex: 1,
			}}
			style={{
				backgroundColor: theme.colors.surface,
			}}
			{...props}
		/>
	);
};

export default AuthContainer;
